import React from "react";

export function ChevronRightIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30px"
      height="30px"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        fill="#ffffff"
        transform="rotate(180 20 20)"
        d="M14.603,1.14c0.752,0.361,1.058,1.238,0.682,1.959L6.472,19.994l8.815,16.892
      c0.383,0.72,0.085,1.601-0.666,1.968c-0.75,0.367-1.669,0.082-2.053-0.638c-0.003-0.007-0.007-0.013-0.011-0.021L3.401,20.649
      c-0.216-0.413-0.216-0.898,0-1.31l9.156-17.547C12.935,1.072,13.851,0.781,14.603,1.14z"
      />
    </svg>
  );
}
